import {
  authentication_repository,
  consumption_history_repository,
} from '@/repositories';
import { DateTime } from 'luxon';

function _getGroupByForDateRange(date_lower_boundary, date_upper_boundary) {
  const start_date = DateTime.fromFormat(date_lower_boundary, 'yyyy-MM-dd');
  const end_date = DateTime.fromFormat(date_upper_boundary, 'yyyy-MM-dd');

  if (end_date.diff(start_date, 'months').months > 3) {
    return '1_month';
  }

  if (end_date.diff(start_date, 'weeks').weeks > 2) {
    return '1_week';
  }

  return '1_day';
}

const state = () => ({ });

const getters = { };

const actions = {
  async getOrganizationStatisticsConnectionsByTimePeriod(_, input) {
    const {
      date_lower_boundary,
      date_upper_boundary,
    } = input;

    if (!date_lower_boundary || !date_upper_boundary) {
      return {
        statistic_list: [],
        group_by: null,
      };
    }

    const group_by = _getGroupByForDateRange(date_lower_boundary, date_upper_boundary);

    const {
      statistic_list,
    } = await authentication_repository.getOrganizationStatisticsConnections({
      ...input,
      group_by,
    });

    return {
      statistic_list,
      group_by,
    };
  },
  async getOrganizationStatisticsConnections(_, input) {
    const {
      date_lower_boundary,
      date_upper_boundary,
    } = input;

    if (!date_lower_boundary || !date_upper_boundary) {
      return [];
    }

    const {
      statistic_list,
    } = await authentication_repository.getOrganizationStatisticsConnections(input);

    return statistic_list;
  },
  async getUserStatisticsConnections(_, input) {
    const {
      date_lower_boundary,
      date_upper_boundary,
    } = input;

    if (!date_lower_boundary || !date_upper_boundary) {
      return [];
    }

    const {
      statistic_list,
    } = await authentication_repository.getUserStatisticsConnections(input);

    return statistic_list;
  },
  async getOrganizationStatisticsConsultedContactsByTimePeriod(_, input) {
    const {
      date_lower_boundary,
      date_upper_boundary,
    } = input;

    if (!date_lower_boundary || !date_upper_boundary) {
      return {
        statistic_list: [],
        group_by: null,
      };
    }

    const group_by = _getGroupByForDateRange(date_lower_boundary, date_upper_boundary);

    const {
      statistic_list,
    } = await consumption_history_repository.getOrganizationStatisticsConsultedContacts({
      ...input,
      group_by,
    });

    return {
      statistic_list,
      group_by,
    };
  },
  async getOrganizationStatisticsConsultedContacts(_, input) {
    const {
      date_lower_boundary,
      date_upper_boundary,
    } = input;

    if (!date_lower_boundary || !date_upper_boundary) {
      return [];
    }

    const {
      statistic_list,
    } = await consumption_history_repository.getOrganizationStatisticsConsultedContacts(input);

    return statistic_list;
  },
  async getUserStatisticsConsultedContacts(_, input) {
    const {
      date_lower_boundary,
      date_upper_boundary,
    } = input;

    if (!date_lower_boundary || !date_upper_boundary) {
      return [];
    }

    const {
      statistic_list,
    } = await consumption_history_repository.getUserStatisticsConsultedContacts(input);

    return statistic_list;
  },
  async getOrganizationStatisticsConsultedAccountsByTimePeriod(_, input) {
    const {
      date_lower_boundary,
      date_upper_boundary,
    } = input;

    if (!date_lower_boundary || !date_upper_boundary) {
      return {
        statistic_list: [],
        group_by: null,
      };
    }

    const group_by = _getGroupByForDateRange(date_lower_boundary, date_upper_boundary);

    const {
      statistic_list,
    } = await consumption_history_repository.getOrganizationStatisticsConsultedAccounts({
      ...input,
      group_by,
    });

    return {
      statistic_list,
      group_by,
    };
  },
  async getOrganizationStatisticsConsultedAccounts(_, input) {
    const {
      date_lower_boundary,
      date_upper_boundary,
    } = input;

    if (!date_lower_boundary || !date_upper_boundary) {
      return [];
    }

    const {
      statistic_list,
    } = await consumption_history_repository.getOrganizationStatisticsConsultedAccounts(input);

    return statistic_list;
  },

  async getUserStatisticsConsultedAccounts(_, input) {
    const {
      date_lower_boundary,
      date_upper_boundary,
    } = input;

    if (!date_lower_boundary || !date_upper_boundary) {
      return [];
    }

    const {
      statistic_list,
    } = await consumption_history_repository.getUserStatisticsConsultedAccounts(input);

    return statistic_list;
  },
};

const mutations = { };

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
